import { makeAutoObservable } from 'mobx'
import CheckableMap from 'src/models/CheckableMap'

import { StudentWorksheetProblem } from '.'

export class StudentWorksheetProblemColl {
  constructor(
    private studentWorksheetProblemColl: CheckableMap<
      StudentWorksheetProblem['id'],
      StudentWorksheetProblem
    >,
  ) {
    makeAutoObservable(this)
  }

  get toArr() {
    return [...this.studentWorksheetProblemColl.values()]
  }

  get checkSize() {
    return this.studentWorksheetProblemColl.checkSize
  }

  get toCheckedValues() {
    return this.studentWorksheetProblemColl.toCheckedValues
  }

  get toCheckedIds() {
    return this.studentWorksheetProblemColl.toCheckedKeys
  }

  get hasUnknownProblem() {
    return this.studentWorksheetProblemColl.toArr.some(({ result }) => result === 'UNKNOWN')
  }

  get(key: number) {
    return this.studentWorksheetProblemColl.get(key)
  }

  toggleCheck(key: number) {
    this.studentWorksheetProblemColl.toggleCheck(key)
  }

  delete(key: number) {
    this.studentWorksheetProblemColl.delete(key)
  }

  isChecked(key: number) {
    return this.studentWorksheetProblemColl.isChecked(key)
  }

  clearAllCheck() {
    this.studentWorksheetProblemColl.clearAllCheck()
  }
}
